<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">分摊医美费用生成凭证</span>
      <span class="dark4-color ">提示：按 Ctrl + F 键并输入可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
      <account-date-choose v-model="accountDate"/>
      <Button color="normal" @click="exportExcel" class="margin-left">下载导入模版</Button>
      <Button color="primary" @click="importExcel" class="margin-left">导入数据</Button>
<!--      <Button color="normal" @click="addVoucher" class="margin-left">生成凭证</Button>-->
      <Button :disabled="isGeneratingVoucher" :loading="isGeneratingVoucher" color="normal" @click="addVoucher" class="margin-left">生成凭证</Button>
      <Button color="normal" @click="clearImportData" class="margin-left">清理导入数据</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="dataList" :border="true" stripe>
        <TableItem title="序号" :width="40">
          <template v-slot="{ index, data }">
            {{  index + 1 }}
          </template>
        </TableItem>
        <TableItem title="部门名称" prop="dianName" :width="100"></TableItem>
        <TableItem title="工资" prop="h300401"></TableItem>
        <TableItem title="房租费" prop="h300402"></TableItem>
        <TableItem title="装修费" prop="h300403"></TableItem>
        <TableItem title="燃气水电费" prop="h300404"></TableItem>
        <TableItem title="工商税费" prop="h300405"></TableItem>
        <TableItem title="折旧费" prop="h300406"></TableItem>
        <TableItem title="低值易耗" prop="h300407"></TableItem>
        <TableItem title="仪器维修" prop="h30040801"></TableItem>
        <TableItem title="场地维修" prop="h30040802"></TableItem>
        <TableItem title="资产维修" prop="h30040803"></TableItem>
        <TableItem title="水电维修" prop="h30040804"></TableItem>
        <TableItem title="其他维修" prop="h30040805"></TableItem>
        <TableItem title="社保费" prop="h300409"></TableItem>
        <TableItem title="探亲费" prop="h30041001"></TableItem>
        <TableItem title="福利费" prop="h30041002"></TableItem>
        <TableItem title="电话费" prop="h300411"></TableItem>
        <TableItem title="办公费" prop="h30041201"></TableItem>
        <TableItem title="业务费" prop="h30041202"></TableItem>
        <TableItem title="差旅费" prop="h300413"></TableItem>
        <TableItem title="市内交通费" prop="h300414"></TableItem>
        <TableItem title="运杂费" prop="h300415"></TableItem>
        <TableItem title="汽车费" prop="h30041601"></TableItem>
        <TableItem title="修理费" prop="h30041602"></TableItem>
        <TableItem title="保险费" prop="h30041603"></TableItem>
        <TableItem title="路桥费" prop="h30041604"></TableItem>
        <TableItem title="停车费" prop="h30041605"></TableItem>
        <TableItem title="洗车费" prop="h30041606"></TableItem>
        <TableItem title="装饰费" prop="h30041607"></TableItem>
        <TableItem title="罚款费" prop="h30041608"></TableItem>
        <TableItem title="赔偿费" prop="h30041609"></TableItem>
        <TableItem title="其他" prop="h30041610"></TableItem>
        <TableItem title="广告费" prop="h300417"></TableItem>
        <TableItem title="请客费" prop="h30041801"></TableItem>
        <TableItem title="送礼费" prop="h30041802"></TableItem>
        <TableItem title="接待费" prop="h30041803"></TableItem>
        <TableItem title="医美辅助品购置" prop="h30041901"></TableItem>
        <TableItem title="科美辅助品购置" prop="h30041902"></TableItem>
        <TableItem title="生美辅助品购置" prop="h30041903"></TableItem>
        <TableItem title="日用辅助品购置" prop="h30041904"></TableItem>
        <TableItem title="奖品费" prop="h300420"></TableItem>
        <TableItem title="罚款" prop="h30042101"></TableItem>
        <TableItem title="赔偿" prop="h30042102"></TableItem>
        <TableItem title="撤店直接损失" prop="h300422"></TableItem>
        <TableItem title="投资损失" prop="h300423"></TableItem>
        <TableItem title="操作" align="center" >
          <div class="actions" slot-scope="{data}">
            <span  @click="remove(data)">删除</span>
          </div>
        </TableItem>
      </Table>

    </div>


    <div class="h-panel-bar">
      <span class="h-panel-title">保存分摊医美费用</span>
    </div>
    <div class="margin-right-left margin-top">
<!--      <Button color="primary"  @click="save" class="margin-left">保存数据</Button>-->
      <Button :disabled="loading" :loading="loading" color="primary" @click="save" class="margin-left">保存数据</Button>
      <Button :loading="loading" :disabled="selectedItems.length === 0" color="red" @click="batchDelete" class="margin-left">批量删除</Button>
      <Button color="normal" @click="exportExcel1" class="margin-left">导出数据</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="dataListym" :border="true" @select="handleSelectChange" :checkbox="true" stripe>
        <TableItem title="序号" :width="40">
          <template v-slot="{ index, data }">
            {{  index + 1 }}
          </template>
        </TableItem>
        <TableItem title="部门名称" prop="dianName" :width="100"></TableItem>
        <TableItem title="日期" prop="heusanDate" :width="80"></TableItem>
        <TableItem title="工资" prop="h300401"></TableItem>
        <TableItem title="房租费" prop="h300402"></TableItem>
        <TableItem title="装修费" prop="h300403"></TableItem>
        <TableItem title="燃气水电费" prop="h300404"></TableItem>
        <TableItem title="工商税费" prop="h300405"></TableItem>
        <TableItem title="折旧费" prop="h300406"></TableItem>
        <TableItem title="低值易耗" prop="h300407"></TableItem>
        <TableItem title="修理费" prop="h300408"></TableItem>
        <TableItem title="社保费" prop="h300409"></TableItem>
        <TableItem title="探亲福利费" prop="h300410"></TableItem>
        <TableItem title="电话费" prop="h300411"></TableItem>
        <TableItem title="办公业务费" prop="h300412"></TableItem>
        <TableItem title="差旅费" prop="h300413"></TableItem>
        <TableItem title="市内交通费" prop="h300414"></TableItem>
        <TableItem title="运杂费" prop="h300415"></TableItem>
        <TableItem title="汽车费" prop="h300416"></TableItem>
        <TableItem title="广告费" prop="h300417"></TableItem>
        <TableItem title="公关招待费" prop="h300418"></TableItem>
        <TableItem title="零星购置" prop="h300419"></TableItem>
        <TableItem title="奖品费" prop="h300420"></TableItem>
        <TableItem title="罚款赔偿" prop="h300421"></TableItem>
        <TableItem title="撤店直接损失" prop="h300422"></TableItem>
        <TableItem title="投资损失" prop="h300423"></TableItem>
      </Table>
      <div class="margin-top-bottom">
        <Pagination v-model="pageInfo" align="center" layout="pager" small/>
      </div>
    </div>
  </app-content>

</template>

<script>
import {mapState} from 'vuex';
import moment from "moment/moment";
import * as XLSX from 'xlsx';

// 定义数据结构模板
const DATA_TEMPLATE = {
  dianName: '',
  h300401: '',
  h300402: '',
  h300403: '',
  h300404: '',
  h300405: '',
  h300406: '',
  h300407: '',
  h30040801: '',
  h30040802: '',
  h30040803: '',
  h30040804: '',
  h30040805: '',
  h300409: '',
  h30041001: '',
  h30041002: '',
  h300411: '',
  h30041201: '',
  h30041202: '',
  h300413: '',
  h300414: '',
  h300415: '',
  h30041601: '',
  h30041602: '',
  h30041603: '',
  h30041604: '',
  h30041605: '',
  h30041606: '',
  h30041607: '',
  h30041608: '',
  h30041609: '',
  h30041610: '',
  h300417: '',
  h30041801: '',
  h30041802: '',
  h30041803: '',
  h30041901: '',
  h30041902: '',
  h30041903: '',
  h30041904: '',
  h300420: '',
  h30042101: '',
  h30042102: '',
  h300422: '',
  h300423: '',
};
/**
 * 分摊医美费用·
 */
export default {
  name: "FenPeiFeiYong",
  data() {
    return {
      //数据列表
      dataList: [],
      //数据库数据
      dataListym: [],
      //数据库将要数据保存
      dataListbc: [],
      // 已选中的行数据数组
      selectedItems: [],
      loading: false,
      isGeneratingVoucher: false,
      //科目代码列表
      voucherSelect: [],
      //需要的科目代码列表
      result: [],
      //贷方科目
      creditSubject: null,
      accountDate: null,
      // 辅助类别-部门-往来
      auxiliary: null,
      // 辅助项目-店名信息
      auxiliaryItem: null,
      // 表单数据对象，用于存储凭证相关信息
      form: {
        voucherId: '',
        // 凭证备注信息，初始为空字符串
        remark: '',
        // 凭证字号，例如“记”字，初始为空字符串
        word: '记',
        // 凭证编号，初始为空字符串
        code: 9999,
        // 凭证日期，格式为字符串，初始为空字符串
        voucherDate:'',
        // 是否为结转凭证，布尔类型，初始为 false
        carryForward: false,
      },
      // 科目代码列表，初始为空数组
      subjectCodes: [],
      // 分页信息
      pageInfo: {
        // 当前页码，初始为第 1 页
        page: 1,
        // 数据总条数，初始为 0
        total: 0
      },
      // 验证数据列表
      validData: [],
    }
  },
  computed: {
    ...mapState(['currentAccountSets', 'myAccountSets','User'])
  },
  methods: {

    clearImportData() {
      this.dataList = [];
      this.loadListBuMen();
      this.$Message.success('导入数据已清空！');
    },


    batchDelete() {
      // 检查是否有选中项
      if (this.selectedItems.length === 0) {
        this.$Message.error('请选择要删除的数据！');
        return;
      }
      // 显示确认对话框，提示删除数量
      this.$Confirm(`确认要删除选中的 ${this.selectedItems.length} 条数据吗？`, '批量删除').then(() => {
        this.loading1 = true;
        // 提取所有选中项的 ID
        const ids = this.selectedItems.map(item => item.id);

        this.$api.bumenhuizong.qzymfentan.batchDelete(ids).then(() => {
          this.$Message.success(`成功删除 ${this.selectedItems.length} 条数据！`);
          this.selectedItems = [];
          this.loadList();
        }).catch(() => {
          this.$Message.error('批量删除失败，请重试！');
        }).finally(() => {
          this.loading = false;
        });
      }).catch((error) => {
        // 处理用户取消操作，避免HeyUI的cancel错误
        if (error !== 'cancel') {
          const isCancelError = error === 'cancel' || (error && error.message === 'cancel')
          if (!isCancelError) {
            console.error('确认对话框错误:', error);
          }
        }
        // 用户点击取消按钮，不做任何处理
        this.loading = false;
      })
    },

    /**
     * 保存数据到数据库
     * @description 验证数据，处理数据，批量保存到数据库
     */
    async save() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      // console.log("dataList JSON格式:", JSON.stringify(this.dataList, null, 2));
      this.validateDataList();
      if (this.validData.length === 0) {
        this.$Message.error('请先导入数据后再保存！');
        this.loading = false;
        return;
      }
      if (this.dataListym.length > 0) {
        this.$Message.error('请先删除已保存过的数据，再保存！');
        this.loading = false;
        return;
      }
      this.dataListbc = [];
      this.processAndAddToDataListym();

      // console.log("dataListym:", this.dataListym);
      // console.log("dataListym JSON格式:", JSON.stringify(this.dataListym, null, 2));
      try {
        // 保存资产负债表数据（批量保存）
        await this.$api.bumenhuizong.qzymfentan.batchUpdate(this.dataListbc);

        this.loadList();
        this.$Message.success('数据保存成功！');
      } catch (error) {
        // 如果错误是 true，说明实际保存成功了，只是 Ajax 封装有问题
        if (error === true) {
          this.loadList();
          this.$Message.success('数据保存成功！');
        } else {
          console.error('保存失败:', error);
          this.$Message.error('数据保存失败，请重试！');
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * 验证 dataList 中每个店面的费用数据
     * @description 检查每个店面是否至少有一项费用数据不为空
     * @returns {Object} 包含有效数据和无效数据的对象
     */
    validateDataList() {
      this.validData = [];
      this.dataList.forEach(item => {
        // 获取所有费用字段的值（排除 dianName）
        const hasValidAmount = Object.keys(DATA_TEMPLATE).some(key => {
          if (key === 'dianName') return false;

          const value = item[key];
          // 检查值是否存在且转换为数字后大于 0
          return value !== '' && value !== null && value !== undefined && Number(value) > 0;
        });
        if (hasValidAmount) {
          this.validData.push(item);
        }
      });
    },

    /**
     * 将验证后的数据加工并添加到 dataListym
     * @description 对 validData 进行加工处理后添加到数据库数据列表
     */
    processAndAddToDataListym() {
      if (!this.validData || this.validData.length === 0) {
        this.$Message.info('没有可处理的有效数据');
        return;
      }

      // 获取当前会计日期，格式化为 YYYY-MM-DD
      const currentDate = this.accountDate || moment().format('YYYY-MM-DD');

      //auxiliaryItem 辅助项目核算
      // 加工数据
      const processedData = this.validData.map(item => {
        // 根据店名从 auxiliaryItem 中查找对应的辅助项目信息
        const auxiliaryInfo = this.auxiliaryItem && this.auxiliaryItem.find(aux => aux.name === item.dianName);
        // 创建新的数据对象，添加额外字段
        return {
          // 保留原有的部门名称
          dianId: auxiliaryInfo ? auxiliaryInfo.id : null,
          dianName: item.dianName,
          accountSetsId: this.currentAccountSets ? this.currentAccountSets.id : null,
          companyName: this.currentAccountSets ? this.currentAccountSets.companyName : null,
          fuzhuId: auxiliaryInfo ? auxiliaryInfo.accountingCategoryId : null,
          fuzhuName: "部门",
          // 添加核算日期
          heusanDate: currentDate,
          createDate: moment().format('YYYY-MM-DD HH:mm:ss'),//创建时间
          // 添加部门信息
          // 映射各个费用字段，确保数据类型正确
          h300401: Number(item.h300401) || 0,
          h300402: Number(item.h300402) || 0,
          h300403: Number(item.h300403) || 0,
          h300404: Number(item.h300404) || 0,
          h300405: Number(item.h300405) || 0,
          h300406: Number(item.h300406) || 0,
          h300407: Number(item.h300407) || 0,
          // 合并维修费用字段（如果后端需要合并的话）
          h300408: (Number(item.h30040801) || 0) +
              (Number(item.h30040802) || 0) +
              (Number(item.h30040803) || 0) +
              (Number(item.h30040804) || 0) +
              (Number(item.h30040805) || 0),
          h300409: Number(item.h300409) || 0,
          // 合并探亲费和福利费
          h300410: (Number(item.h30041001) || 0) + (Number(item.h30041002) || 0),
          h300411: Number(item.h300411) || 0,
          // 合并办公费和业务费
          h300412: (Number(item.h30041201) || 0) + (Number(item.h30041202) || 0),
          h300413: Number(item.h300413) || 0,
          h300414: Number(item.h300414) || 0,
          h300415: Number(item.h300415) || 0,
          // 合并汽车相关费用
          h300416: (Number(item.h30041601) || 0) +
              (Number(item.h30041602) || 0) +
              (Number(item.h30041603) || 0) +
              (Number(item.h30041604) || 0) +
              (Number(item.h30041605) || 0) +
              (Number(item.h30041606) || 0) +
              (Number(item.h30041607) || 0) +
              (Number(item.h30041608) || 0) +
              (Number(item.h30041609) || 0) +
              (Number(item.h30041610) || 0),
          h300417: Number(item.h300417) || 0,
          // 合并公关招待费
          h300418: (Number(item.h30041801) || 0) +
              (Number(item.h30041802) || 0) +
              (Number(item.h30041803) || 0),
          // 合并零星购置费
          h300419: (Number(item.h30041901) || 0) +
              (Number(item.h30041902) || 0) +
              (Number(item.h30041903) || 0) +
              (Number(item.h30041904) || 0),
          h300420: Number(item.h300420) || 0,
          // 合并罚款和赔偿
          h300421: (Number(item.h30042101) || 0) + (Number(item.h30042102) || 0),
          h300422: Number(item.h300422) || 0,
          h300423: Number(item.h300423) || 0,
        };
      });

      // 将加工后的数据添加到 dataListbc
      // 方式1：追加到现有数据后面
      this.dataListbc.push(...processedData);
    },


    exportExcel1() {
      try {
        // 导出所有数据
        const exportData = this.dataListym;
        if (exportData.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        // 准备导出数据，保持与表格显示一致的顺序
        const data = exportData.map((item, index) => {
          return {
            '序号': index + 1,
            '部门名称': item.dianName || '',
            '日期': item.heusanDate || '',
            '工资': item.h300401 || '',
            '房租费': item.h300402 || '',
            '装修费': item.h300403 || '',
            '燃气水电费': item.h300404 || '',
            '工商税费': item.h300405 || '',
            '折旧费': item.h300406 || '',
            '低值易耗': item.h300407 || '',
            '修理费': item.h300408 || '',
            '社保费': item.h300409 || '',
            '探亲福利费': item.h300410 || '',
            '电话费': item.h300411 || '',
            '办公业务费': item.h300412 || '',
            '差旅费': item.h300413 || '',
            '市内交通费': item.h300414 || '',
            '运杂费': item.h300415 || '',
            '汽车费': item.h300416 || '',
            '广告费': item.h300417 || '',
            '公关招待费': item.h300418 || '',
            '零星购置': item.h300419 || '',
            '奖品费': item.h300420 || '',
            '罚款赔偿': item.h300421 || '',
            '撤店直接损失': item.h300422 || '',
            '投资损失': item.h300423 || '',
          };
        });

        // 创建工作表
        const ws = XLSX.utils.json_to_sheet(data, {skipHeader: false});

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '分摊医美费用');

        // 导出文件
        XLSX.writeFile(wb, '分摊医美费用.xlsx');

        // 显示成功提示
        this.$Message.success('数据导出成功，请查看浏览器下载列表');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('导出失败');
      }
    },

    /**
     * 处理表格行选择变化事件
     *
     * 当用户勾选或取消勾选表格行时，更新已选中项列表
     * @param {Array} checks - 当前选中的所有行数据数组
     */
    handleSelectChange(checks) {
      this.selectedItems = checks;
    },

    // ... existing code ...
    async initVoucherData() {
      await this.loadVoucherSelectAndInit();
    },

    /**
     * 加载凭证选择数据并初始化
     * @description 当 localStorage 中没有 voucherSelect 数据时，从接口加载并缓存
     */
    loadVoucherSelectAndInit() {
      this.$api.setting.subject.voucherSelect().then(({data}) => {
        if (!data || !Array.isArray(data) || data.length === 0) {
          console.warn('API 返回的 voucherSelect 为空数组或格式不正确');
          this.$Message.warning('未获取到科目配置数据，请检查系统设置');
          this.subjectCodes = [];
          return;
        }
        // 直接存储数组对象
        this.subjectCodes = data;
        this.getSubjectCodesFromTemplate(data);
      }).catch(error => {
        console.error('获取凭证选择数据失败:', error);
        this.$Message.error('获取科目配置失败，请刷新页面重试');
      });
    },


    /**
     * 获取 DATA_TEMPLATE 中对应的科目代码信息
     * @description 从 voucherSelect 里查找与模板字段匹配的科目信息
     * @param {Array} voucherSelect - 科目代码列表
     * @returns {Array} 包含科目代码信息的数组，每个元素包含 code 和完整科目对象
     */
    getSubjectCodesFromTemplate(voucherSelect) {
      // 如果没有传入参数，使用 this.subjectCodes
      if (!voucherSelect) {
        voucherSelect = this.subjectCodes;
      }

      // 检查是否为空或 undefined
      if (!voucherSelect || !Array.isArray(voucherSelect)) {
        console.warn('未找到 subjectCodes 数据或数据格式不正确');
        return this.result = [];
      }
      this.result = [];
      this.creditSubject = voucherSelect.find(subject => subject.code === '2001');

      // 遍历 DATA_TEMPLATE 的所有字段
      for (const key in DATA_TEMPLATE) {
        // 跳过 dianName 字段
        if (key === 'dianName') {
          continue;
        }

        // 去掉字段名的 'h' 前缀，获取科目代码
        // 例如：h300401 -> 300401
        const subjectCode = key.substring(1);

        // 在 voucherSelect 中查找匹配的科目
        const matchedSubject = voucherSelect.find(subject => {
          // 假设 voucherSelect 中的科目对象有 code 字段
          return String(subject.code) === String(subjectCode);
        });

        // 如果找到匹配的科目，添加到结果数组
        if (matchedSubject) {
          this.result.push({
            templateKey: key,           // 模板中的字段名，如 'h300401'
            subjectCode: subjectCode,    // 科目代码，如 '300401'
            subjectInfo: matchedSubject  // 完整的科目信息对象
          });
        } else {
          console.warn(`未找到科目代码 ${subjectCode} 对应的信息`);
        }
      }
    },


    remove(item) {
      this.$Confirm("确认删除？").then(() => {
        // 从 dataList 中过滤掉要删除的项
        this.dataList = this.dataList.filter(d => d.dianName !== item.dianName);
        // 提示删除成功
        this.$Message.success('删除成功！');
      }).catch(() => {
        // 用户取消删除，不做任何操作
      });
    },

    async addVoucher() {

      if (this.isGeneratingVoucher) {
        return;
      }

      this.isGeneratingVoucher = true;

      try {
        // 判断是否已填写数据
        if (this.dataList.length === 0) {
          this.$Message.warning('请先填写数据！');
          return;
        }
        const voucherDetails = [];
        const accountDateMonth = moment(this.accountDate).format('YYYY-MM');
        this.dataList.forEach(item => {
          //部门信息
          const departmentInfo = this.auxiliaryItem.find(v => v.name === item.dianName);
          if (!departmentInfo) {
            return; // 跳过没有部门信息的数据
          }

          // 遍历所有科目代码，为金额大于 0 的费用项目生成凭证明细
          this.result.forEach(({templateKey, subjectCode, subjectInfo}) => {
            const amount = item[templateKey];

            // 判断金额是否有效且大于 0
            if (amount && Number(amount) !== 0) {
              // 生成凭证明细的借方
              voucherDetails.push({
                auxiliary: [departmentInfo],
                debitAmount: amount,
                subjectId: subjectInfo.id,
                direction: subjectInfo.direction,
                subjectName: `${subjectInfo.code}-${subjectInfo.name}`,
                subjectCode: subjectInfo.code,
                auxiliaryTitle: `_${departmentInfo.code}_${departmentInfo.name}`,
                summary: `${accountDateMonth}月份医美费用分配`
              });
            }
          });
        });
        if (voucherDetails.length === 0) {
          this.$Message.warning('没有有效的费用数据，无法生成凭证！');
          return;
        }
        if (!this.creditSubject) {
          this.$Message.error('未找到贷方科目，请检查科目配置！');
          return;
        }
        //合计借方金额
        const totalDebitAmount = voucherDetails.reduce((acc, cur) => acc + Number(cur.debitAmount), 0);
        //贷方凭证明细
        voucherDetails.push({
          auxiliary: [],
          creditAmount: totalDebitAmount,
          subjectId: this.creditSubject.id,
          direction: this.creditSubject.direction,
          subjectName: `${this.creditSubject.code}-${this.creditSubject.name}`,
          subjectCode: this.creditSubject.code,
          auxiliaryTitle: '',
          summary: `${accountDateMonth}月份医美费用分配`
        })
        // 设置凭证日期
        this.form.voucherDate = this.accountDate;

        // 等待获取凭证编号
        const codeRes = await this.$api.voucher.loadCode({
          word: this.form.word,
          currentAccountDate: this.accountDate
        });

        this.form.code = codeRes.data;
        // 等待保存凭证
        const saveRes = await this.$api.voucher.save(Object.assign({}, this.form, {
          details: voucherDetails,
          createMember: this.User.id
        }));

        if (saveRes.success) {
          this.$Message.success('凭证保存成功！');
          this.dataList = [];

        }
      } catch (error) {
        console.error('凭证处理失败:', error);
        this.$Message.error('凭证保存失败！');
      }finally {
        this.isGeneratingVoucher = false;
      }
    },

    /**
     * 导出Excel
     */
    exportExcel() {
      try {
        // 导出所有数据
        const exportData = this.dataList;
        if (exportData.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        // 准备导出数据，保持与表格显示一致的顺序
        const data = exportData.map((item, index) => {
          return {
            '序号': index + 1,
            '部门名称': item.dianName || '',
            '工资': item.h300401 || '',
            '房租费': item.h300402 || '',
            '装修费': item.h300403 || '',
            '燃气水电费': item.h300404 || '',
            '工商税费': item.h300405 || '',
            '折旧费': item.h300406 || '',
            '低值易耗': item.h300407 || '',
            '仪器维修': item.h30040801 || '',
            '场地维修': item.h30040802 || '',
            '资产维修': item.h30040803 || '',
            '水电维修': item.h30040804 || '',
            '其他维修': item.h30040805 || '',
            '社保费': item.h300409 || '',
            '探亲费': item.h30041001 || '',
            '福利费': item.h30041002 || '',
            '电话费': item.h300411 || '',
            '办公费': item.h30041201 || '',
            '业务费': item.h30041202 || '',
            '差旅费': item.h300413 || '',
            '市内交通费': item.h300414 || '',
            '运杂费': item.h300415 || '',
            '燃油费': item.h30041601 || '',
            '修理费': item.h30041602 || '',
            '保险费': item.h30041603 || '',
            '路桥费': item.h30041604 || '',
            '停车费': item.h30041605 || '',
            '洗车费': item.h30041606 || '',
            '装饰费': item.h30041607 || '',
            '罚款费': item.h30041608 || '',
            '赔偿费': item.h30041609 || '',
            '其他': item.h30041610 || '',
            '广告费': item.h300417 || '',
            '请客费': item.h30041801 || '',
            '送礼费': item.h30041802 || '',
            '接待费': item.h30041803 || '',
            '医美辅助品购置': item.h30041901 || '',
            '科美辅助品购置': item.h30041902 || '',
            '生美辅助品购置': item.h30041903 || '',
            '日用辅助品购置': item.h30041904 || '',
            '奖品费': item.h300420 || '',
            '罚款': item.h30042101 || '',
            '赔偿': item.h30042102 || '',
            '撤店直接损失': item.h300422 || '',
            '投资损失': item.h300423 || '',
          };
        });

        // 创建工作表
        const ws = XLSX.utils.json_to_sheet(data, {skipHeader: false});

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '分摊医美费用导入模版');

        // 导出文件
        XLSX.writeFile(wb, '分摊医美费用导入模版.xlsx');

        // 显示成功提示
        this.$Message.success('数据导出成功，请查看浏览器下载列表');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('导出失败');
      }
    },

    submit1() {
      if (this.auxiliaryItem) {
        // 设置加载状态为true，显示加载动画
        this.loading = true;
        console.log("dataForm 数据:", this.dataForm);
        console.log("dataForm JSON格式:", JSON.stringify(this.dataForm, null, 2));

        this.huoqudianshuju();
        console.log("dataForm 数据:", this.dataForm);
        console.log("dataForm JSON格式:", JSON.stringify(this.dataForm, null, 2));
        this.loading = false;
      } else {
        this.$Message.error('请选择经营店！');
        this.loading = false;
      }
    },

    loadListBuMen() {
      this.$api.setting.accountingCategory.list().then(({data}) => {
        // 如果存在数据，则默认选中第一个选项
        if (data.length) {
          this.auxiliary = data[0];
          // 在获取到类别数据后再加载对应的项目列表
          this.$api.accountbook.loadAuxiliaryList2({
            auxiliaryId: this.auxiliary.id
          }).then(({data}) => {
            this.auxiliaryItem = data;
            // console.log("auxiliary:", JSON.stringify(this.auxiliary, null, 2));
            // console.log("auxiliaryItem:", JSON.stringify(this.auxiliaryItem, null, 2));
            // 清空 dataList（避免重复添加）
            this.dataList = [];
            // 遍历每个辅助项目，为每个项目创建一条记录
            data.forEach(item => {
              this.dataList.push({
                ...DATA_TEMPLATE,
                dianName: item.name
              });
            });
          }).catch(() => {
            this.$Message.error('获取项目列表失败！');
          });
        }
      }).catch(() => {
        this.$Message.error('获取类别列表失败！');
      });
      // console.log("auxiliary:", JSON.stringify(data, null, 2));
    },

    /**
     * 导入 Excel 数据
     */
    importExcel() {
      // 创建隐藏的文件输入框
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx,.xls';
      input.style.display = 'none';

      // 监听文件选择变化
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // 检查文件大小（限制 10MB）
        if (file.size > 10 * 1024 * 1024) {
          this.$Message.error('文件大小不能超过 10MB');
          return;
        }

        const reader = new FileReader();

        // 文件读取完成的回调
        reader.onload = (event) => {
          try {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, {type: 'array'});

            // 获取第一个工作表
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // 将工作表转换为 JSON 数据
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            if (jsonData.length === 0) {
              this.$Message.warning('Excel 文件中没有数据');
              return;
            }

            // 处理数据并添加到 dataList
            const importedData = this.processImportData(jsonData);

            if (importedData.validCount === 0) {
              this.$Message.warning('没有有效的数据可导入');
              return;
            }

            // 显示确认对话框
            this.$Confirm(`确定要导入 ${importedData.validCount} 条数据吗？导入后将替换现有数据。`, '导入确认')
                .then(() => {
                  // 先清空原有数据
                  this.dataList = [];
                  // 将导入的数据添加到 dataList
                  this.dataList.push(...importedData.validData);
                  this.$Message.success(`成功导入 ${importedData.validCount} 条数据`);
                })
                .catch(() => {
                  // 用户取消导入
                });

          } catch (error) {
            console.error('导入失败:', error);
            this.$Message.error('文件解析失败，请确保文件格式正确');
          } finally {
            // 清理文件输入框
            input.remove();
          }
        };

        // 文件读取失败的回调
        reader.onerror = () => {
          this.$Message.error('文件读取失败');
          input.remove();
        };

        // 读取文件为 ArrayBuffer
        reader.readAsArrayBuffer(file);
      };

      // 触发文件选择
      document.body.appendChild(input);
      input.click();
    },

    /**
     * 处理导入的 Excel 数据
     * @param {Array} jsonData - 从 Excel 解析出的原始数据
     * @returns {Object} 包含有效数据和错误信息的对象
     */
    processImportData(jsonData) {
      const result = [];
      const errorMessages = [];
      const processedNames = new Set(); // 用于记录已处理的部门名称，防止重复

      // 获取所有有效的部门名称集合（从 auxiliaryItem 中提取）
      const validDepartmentNames = new Set();
      if (this.auxiliaryItem && Array.isArray(this.auxiliaryItem)) {
        this.auxiliaryItem.forEach(item => {
          validDepartmentNames.add(item.name);
        });
      }

      // 格式化数字为两位小数的辅助函数
      const formatToTwoDecimals = (value) => {
        if (value === '' || value === null || value === undefined) {
          return '';
        }
        const num = Number(value);
        if (isNaN(num) || num === 0) {
          return '';
        }
        return Number(num.toFixed(2));
      };

      jsonData.forEach((row, index) => {
        // 跳过表头（如果第一行是表头且没有部门名称）
        if (index === 0 && !row['部门名称'] && row['序号'] === 1) {
          return;
        }

        // 检查是否有部门名称，没有则跳过
        const dianName = row['部门名称'];
        if (!dianName) {
          errorMessages.push(`第 ${index + 1} 行：缺少部门名称，已跳过`);
          return;
        }

        // 验证 1：检查部门名称是否在 auxiliaryItem 中存在
        if (!validDepartmentNames.has(dianName)) {
          errorMessages.push(`第 ${index + 1} 行：部门名称 "${dianName}" 不在允许的列表中，已跳过`);
          return;
        }

        // 验证 2：检查部门名称是否重复
        if (processedNames.has(dianName)) {
          errorMessages.push(`第 ${index + 1} 行：部门名称 "${dianName}" 重复，已跳过`);
          return;
        }

        // 标记该部门名称已处理
        processedNames.add(dianName);

        // 构建数据对象，使用模板展开运算符
        const dataItem = {
          ...DATA_TEMPLATE,
          dianName: dianName,
          // 映射各个字段：将 Excel 列名转换为对应的科目代码字段，并保留两位小数
          h300401: formatToTwoDecimals(row['工资']),
          h300402: formatToTwoDecimals(row['房租费']),
          h300403: formatToTwoDecimals(row['装修费']),
          h300404: formatToTwoDecimals(row['燃气水电费']),
          h300405: formatToTwoDecimals(row['工商税费']),
          h300406: formatToTwoDecimals(row['折旧费']),
          h300407: formatToTwoDecimals(row['低值易耗']),
          h30040801: formatToTwoDecimals(row['仪器维修']),
          h30040802: formatToTwoDecimals(row['场地维修']),
          h30040803: formatToTwoDecimals(row['资产维修']),
          h30040804: formatToTwoDecimals(row['水电维修']),
          h30040805: formatToTwoDecimals(row['其他维修']),
          h300409: formatToTwoDecimals(row['社保费']),
          h30041001: formatToTwoDecimals(row['探亲费']),
          h30041002: formatToTwoDecimals(row['福利费']),
          h300411: formatToTwoDecimals(row['电话费']),
          h30041201: formatToTwoDecimals(row['办公费']),
          h30041202: formatToTwoDecimals(row['业务费']),
          h300413: formatToTwoDecimals(row['差旅费']),
          h300414: formatToTwoDecimals(row['市内交通费']),
          h300415: formatToTwoDecimals(row['运杂费']),
          h30041601: formatToTwoDecimals(row['燃油费']),
          h30041602: formatToTwoDecimals(row['修理费']),
          h30041603: formatToTwoDecimals(row['保险费']),
          h30041604: formatToTwoDecimals(row['路桥费']),
          h30041605: formatToTwoDecimals(row['停车费']),
          h30041606: formatToTwoDecimals(row['洗车费']),
          h30041607: formatToTwoDecimals(row['装饰费']),
          h30041608: formatToTwoDecimals(row['罚款费']),
          h30041609: formatToTwoDecimals(row['赔偿费']),
          h30041610: formatToTwoDecimals(row['其他']),
          h300417: formatToTwoDecimals(row['广告费']),
          h30041801: formatToTwoDecimals(row['请客费']),
          h30041802: formatToTwoDecimals(row['送礼费']),
          h30041803: formatToTwoDecimals(row['接待费']),
          h30041901: formatToTwoDecimals(row['医美辅助品购置']),
          h30041902: formatToTwoDecimals(row['科美辅助品购置']),
          h30041903: formatToTwoDecimals(row['生美辅助品购置']),
          h30041904: formatToTwoDecimals(row['日用辅助品购置']),
          h300420: formatToTwoDecimals(row['奖品费']),
          h30042101: formatToTwoDecimals(row['罚款']),
          h30042102: formatToTwoDecimals(row['赔偿']),
          h300422: formatToTwoDecimals(row['撤店直接损失']),
          h300423: formatToTwoDecimals(row['投资损失'])
        };

        result.push(dataItem);
      });

      // 如果有错误信息，显示给用户
      if (errorMessages.length > 0) {
        console.warn('导入数据验证警告:', errorMessages);
        // 只显示前 5 条错误信息，避免提示框过长
        const displayErrors = errorMessages.slice(0, 5).join('\n');
        const moreCount = errorMessages.length - 5;
        this.$Message.warning({
          content: `数据验证发现以下问题：\n${displayErrors}${moreCount > 0 ? `\n还有 ${moreCount} 条错误，请查看控制台详情` : ''}`,
          duration: 10
        });
      }

      return {
        validData: result,
        errors: errorMessages,
        totalCount: jsonData.length,
        validCount: result.length
      };
    },


    loadList() {
      if (!this.accountDate) {
        console.warn('accountDate 为空，不加载数据');
        return;
      }
      this.$api.bumenhuizong.qzymfentan.list(this.accountDate)
          .then(({data}) => {
            this.dataListym = data;
          })
          .catch((error) => {
            console.error('加载资产负债表失败:', error);
            // 不显示错误提示，因为可能是正常情况（没有数据）
          });

    },
  },

  watch: {
    accountDate(newVal) {
      if (newVal) {
        // 创建日期对象
        const date = new Date(newVal);

        // 检查当前日期是否已经是1号
        if (date.getDate() !== 1) {
          // 设置为1号
          date.setDate(1);
          // 格式化为 YYYY-MM-DD
          const firstDay = date.toISOString().slice(0, 10);

          // 更新 accountDate 为每月1号
          this.$nextTick(() => {
            if (this.accountDate !== firstDay) {
              this.accountDate = firstDay;
            }
          });
        } else {
          // 如果已经是 1 号，直接加载数据
          this.loadList();

        }
      }
    }
  },
  mounted() {

    this.loadListBuMen();
    this.initVoucherData();
  }
}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center;  /* 垂直居中对齐 */
}
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 35px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>